import * as React from 'react';
import { antGrey, hexStringToRGBAString } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';

interface StepItemLinkContainerProps {
    isActive?: boolean;
    isSubStep?: boolean;
    hasIcon?: boolean;
    children: React.ReactNode;
}

export const StepItemLinkContainer = ({
    isActive = false,
    isSubStep = false,
    hasIcon = false,
    children,
}: StepItemLinkContainerProps) => {
    return (
        <div
            style={{
                backgroundColor:
                    isActive ?
                        isSubStep ? hexStringToRGBAString(antGrey.grey5, 0.5)
                        :   antGrey.grey5
                    :   'transparent',
                display: 'flex',
                justifyContent: hasIcon ? 'space-between' : 'flex-end',
                alignItems: 'center',
                paddingLeft: 20,
                paddingRight: 20,
            }}
        >
            {children}
        </div>
    );
};

export const StepItemTextContainer = ({ children }: { children: React.ReactNode }) => {
    return <div style={{ display: 'flex', minWidth: 0, marginLeft: 12, marginRight: 16 }}>{children}</div>;
};

export const StepItemText = ({
    children,
    shouldBoldText = false,
    nonBlocking = false,
}: {
    children: React.ReactNode;
    shouldBoldText?: boolean;
    nonBlocking?: boolean;
}) => {
    return (
        <Text
            style={{
                fontSize: 14,
                textAlign: 'right',
                fontWeight: shouldBoldText ? 600 : 400,
                color: nonBlocking ? antGrey.grey7 : 'initial',
            }}
            ellipsis
        >
            {children}
        </Text>
    );
};
